import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ClientCategoryControllerService } from './api/clientCategoryController.service';
import { ClientTagTranscriptionControllerService } from './api/clientTagTranscriptionController.service';
import { ClientTranscriptionControllerService } from './api/clientTranscriptionController.service';
import { ManagementCategoryTranscriptionControllerService } from './api/managementCategoryTranscriptionController.service';
import { ManagementTagTranscriptionControllerService } from './api/managementTagTranscriptionController.service';
import { ManagementTranscriptionControllerService } from './api/managementTranscriptionController.service';
import { UploadControllerService } from './api/uploadController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ClientCategoryControllerService,
    ClientTagTranscriptionControllerService,
    ClientTranscriptionControllerService,
    ManagementCategoryTranscriptionControllerService,
    ManagementTagTranscriptionControllerService,
    ManagementTranscriptionControllerService,
    UploadControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
